<template>
  <div class="row m-0 white_bg position-relative" >
    <div class="note bold position-absolute top-0 start-50 translate-middle-x" v-if="subscription.note">
      {{subscription.note}}
    </div>
    <div class="current bold position-absolute top-0 start-50 translate-middle" v-if="theUser.subscription && theUser.subscription.details.type === subscription.type && theUser.subscription.paystack && theUser.subscription.paystack.status === 'active'">
      Current Plan
    </div>
    <div class="col-12 p-4 pt-5">
      <div class="row mx-0 justify-content-center">
        <div class="col-12 p-0 text-uppercase bold text-center">
          <h6>{{subscription.type}}</h6>
        </div>
        <div class="col-1 text-center border_bottom">
        </div>
      </div>
      <div class="row mx-0 my-3 justify-content-center">
        <div class="col-12 p-0 text-center">
          <span class="bigfont bold">R {{subscription.price / 100}}</span>/mo
        </div>
      </div>
      <div class="row mx-0 mb-3 justify-content-center">
        <div class="col-12 p-0 text-center mb-2">
          {{subscription.setupFee}}
        </div>
        <div class="col-12 p-0 text-center mb-2">
          {{subscription.freeTrial.amount}} {{subscription.freeTrial.unit}} free trial
        </div>
        <div class="col-12 p-0 text-center mb-2">
          {{convertB(subscription.storage).amount}} {{convertB(subscription.storage).type}} of storage
        </div>
        <div class="col-12 p-0 text-center mb-2" v-if="subscription.attachments.cap !== 'Unlimited'">
          {{convertB(subscription.attachments.cap).amount}} {{convertB(subscription.attachments.cap).type}} attachment size limit
        </div>
        <div class="col-12 p-0 text-center mb-2" v-else>
          {{subscription.attachments.cap}}<span class="text-uppercase">{{subscription.attachments.unit}}</span> attachment size limit
        </div>
        <div class="col-12 p-0 text-center mb-2">
          Include {{subscription.attachments.type}} types of attachments
        </div>
      </div>
      <!-- <div class="row mx-0 justify-content-center" v-if="theUser && theUser.subscription.lastUpdated > yesterday">
        <div class="col-12 p-0 text-center" v-if="theUser && !theUser.subscription.paystack">
          <button class="btn btn-black" disabled>
            Get Started
          </button>
        </div>
        <div class="col-12 p-0 text-center" v-else>
          <button class="btn btn-primary" v-if="theUser.subscription && theUser.subscription.details.type === subscription.type && theUser.subscription.paystack && theUser.subscription.paystack.status === 'active'" disabled>
            Cancel
          </button>
          <button class="btn btn-primary" v-else  disabled>
            Change
          </button>
        </div>
        <div class="col-12 p-0 text-center smallfont mt-3 ">
          Please allow 24 hours to allow changes to reflect from Paystack. You can update your subscription again on {{nextUpdate}}
        </div>
      </div> -->
      <div class="row mx-0 justify-content-center">
        <div class="col-12 p-0 text-center" v-if="theUser && !theUser.subscription.paystack">
          <button class="btn btn-black" @click="getStarted(subscription)">
            Get Started
            <div class="spinner-border spinner-border-sm" role="status" v-if="isLoading">
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </div>
        <div class="col-12 p-0 text-center" v-else>
          <button class="btn btn-primary" v-if="theUser.subscription && theUser.subscription.details.type === subscription.type && theUser.subscription.paystack && theUser.subscription.paystack.status === 'active'" @click="cancel">
            Cancel
            <div class="spinner-border spinner-border-sm" role="status" v-if="isLoading">
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
          <button class="btn btn-primary" v-else-if="storageTooHigh || attachmentTooBig" disabled>
            Change
          </button>
          <button class="btn btn-primary" v-else  @click="change(subscription)">
            Change
            <div class="spinner-border spinner-border-sm" role="status" v-if="isLoading">
              <span class="visually-hidden">Loading...</span>
            </div>
          </button>
        </div>
        <div class="col-12 p-0 text-center smallfont mt-3 " v-if="storageTooHigh">
          Your storage is too high, you can't move to this subscription as it doesn't offer enough storage space.
        </div>
        <div class="col-12 p-0 text-center smallfont mt-3 " v-else-if="attachmentTooBig">
          Your have a large attachment, you can't move to this subscription as it doesn't offer a big enough attachment size limit.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DateTime from 'luxon/src/datetime.js'

export default {
  name: 'SubscriptionItem',
  props: ['subscription'],
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['messages', 'theUser', 'storageUsed']),
    yesterday () {
      return DateTime.now().plus({ days: -1 }).ts
      // const datePlus90 = DateTime.fromMillis(DateNow).plus({ days: 90 }).ts
    },
    nextUpdate () {
      return DateTime.fromMillis(this.theUser.subscription.lastUpdated).plus({ days: 1 }).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)
    },
    storageTooHigh () {
      if (this.storageUsed > this.subscription.storage) {
        return true
      } else {
        return false
      }
    },
    attachmentTooBig () {
      let ret = false
      Object.entries(this.messages).forEach(entry => {
        const [key, value] = entry
        console.log(key)
        if (value) {
          if (!value.deleted) {
            if (value.uploads) {
              return value.uploads.filter(upload => {
                console.log('upload.size', upload.size)
                console.log('this.subscription.attachments.cap', this.subscription.attachments.cap)
                if (upload.size > this.subscription.attachments.cap) {
                  ret = true
                }
              })
            }
          }
        }
      })
      if (ret === false) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions(['createPaystackSubscription', 'subscribeTo', 'cancelSubscription', 'setTime']),
    async cancel () {
      this.isLoading = true
      const resp = await this.cancelSubscription(this.theUser.subscription.paystack)
      console.log('RESP', resp)
      await this.setUpdateTime()
      if (resp) {
        this.isLoading = false
      }
    },
    async getStarted (val) {
      console.log('getStarted Subscribe TO', val)
      // create sub with start date
      this.isLoading = true
      if (this.theUser && this.theUser.paystackDetails) {
        await this.createPaystackSubscription(val)
      } else {
        await this.subscribeTo(val)
      }
      await this.setUpdateTime()
      this.isLoading = false
    },
    async change (val) {
      console.log('change Subscription TO', val)
      this.isLoading = true
      await this.cancel()
      // create sub with start date
      await this.createPaystackSubscription(val)
      await this.setUpdateTime()
      this.isLoading = false
    },
    async setUpdateTime () {
      const dateNow = Date.now()
      await this.setTime(dateNow)
    },
    convertB (val) {
      var data = {
        amount: 0,
        type: null
      }
      // return Math.round(BtoGB * 100) / 100
      const BtoGB = val / 1000000000
      const BtoMB = val / 1000000
      const BtoKB = val / 1000
      if (val > 999999999) {
        data.amount = Math.round(BtoGB * 100) / 100
        data.type = 'GB'
        return data
      } else if (val > 999999) {
        data.amount = Math.round(BtoMB * 100) / 100
        data.type = 'MB'
        return data
      } else {
        data.amount = Math.round(BtoKB * 100) / 100
        data.type = 'KB'
        return data
      }
    }
  }
}
</script>
<style scoped>
.border_bottom {
  border-bottom: 2px solid ;
}
.bigfont {
  font-size: 2rem;
}
.smallfont {
  font-size: 0.7rem;
}
.note {
  background-color: #a13457;
  font-size: 0.6rem;
  color: #fff;
  text-transform: uppercase;
  padding: 0.2rem 0.75rem;
  width: max-content;
}
.current {
  background-color: #e1af90;
  top: 0;
  font-size: 1.2rem;
  color: #fff;
  padding: 0.5rem 0.75rem;
  width: 90%;
}
.btn-black {
  background-color: #181e28;
  border-color: #181e28;
  border-radius: 1.2rem;
  color: #fff;
}
.btn-black:hover {
  background-color: #4b4b4b;
  border-color: #000000;
}
</style>
